import React from "react"
// import "../styles/DarkMode.css"

const DarkMode = () => {
  let clickedClass = "clicked"
  const body = document.body
  const lightTheme = "light"
  const darkTheme = "dark"
  let theme

  if (localStorage) {
    theme = localStorage.getItem("theme")
  }

  if (theme === lightTheme || theme === darkTheme) {
    body.classList.add(theme)
  } else {
    body.classList.add(lightTheme)
  }

  const switchTheme = e => {
    if (theme === darkTheme) {
      body.classList.replace(darkTheme, lightTheme)
      e.target.classList.remove(clickedClass)
      localStorage.setItem("theme", "light")
      theme = lightTheme
    } else {
      body.classList.replace(lightTheme, darkTheme)
      e.target.classList.add(clickedClass)
      localStorage.setItem("theme", "dark")
      theme = darkTheme
    }
  }

  return (
    // <button
    //   className={theme === "dark" ? clickedClass : ""}
    //   id="darkMode"
    //   onClick={e => switchTheme(e)}
    // >Click</button>
    <div   className={theme === "dark" ? clickedClass : ""}
    id="darkMode"
    onClick={e => switchTheme(e)}>
      <input id="toggle" class="toggle" type="checkbox" />
<div class="background"></div>
<label for="toggle" class="title"> </label>
    </div>

  )
}

export default DarkMode